<script>
export default {
  name: "EmptyLayout"
};
</script>

<template>
  <div class="auth-layout">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.auth-layout {
  min-height: calc(var(--vh, 1vh) * 100);
  background: rgba(205, 206, 208, 0.2)
    url("/public/static/images/error-page-bg.svg") no-repeat right bottom;
  display: flex;
  flex-direction: column;
}
</style>
